import axios from 'axios';
import { apiUrl } from './apiUrl';

export const checkCouponValidity = coupon =>
    axios.get(`${apiUrl}/clientCoupon`, { params: { 'coupon': coupon } })


// WEBPACK FOOTER //
// ./src/baseparking-api/Coupons.js